exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.capitalise,td [data-dt-column=\"8\"] .dtr-data{text-transform:capitalize}td.normal-white-space{white-space:normal !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./src/scss/dashboards/search.scss
// module id = 623
// module chunks = 0